import React, { useState } from "react";
import classNames from "classnames/bind";
import styles from "./History.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-regular-svg-icons";
import { NavLink } from "react-router-dom";
import routes from "~/configs";
import { BASE_TRANSACTIONS_URL } from '~/helper/apiService';

const cx = classNames.bind(styles);

function History() {
  const [phone, setPhone] = useState("");
  const [history, setHistory] = useState([]);
  const [summary, setSummary] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false); // Track if a search was performed
  

  const handleSearch = async () => {
    setError(null);
    setHistory([]);
    setSummary([]);
    setSearched(true); // Mark that a search was performed

    if (!phone || !/^\d{10,15}$/.test(phone)) {
      setError("Vui lòng nhập số điện thoại hợp lệ (10-15 chữ số)");
      setSearched(false);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_TRANSACTIONS_URL}history?phone=${encodeURIComponent(phone)}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || "Lỗi khi lấy dữ liệu");
      }
      setHistory(data.history || []);
      setSummary(data.summary || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={cx("wrapper")}>
      <h1 className={cx("title")}>Tra cứu lịch sử tích điểm</h1>
      <div className={cx("input-container")}>
        <input
          type="text"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="Nhập số điện thoại"
          className={cx("input")}
        />
        <button
          onClick={handleSearch}
          disabled={loading}
          className={cx("button", { "button-disabled": loading })}
        >
          {loading ? "Đang tìm..." : "Tìm kiếm"}
        </button>
      </div>

      {error && <p className={cx("error")}>{error}</p>}

      {summary.length > 0 && (
        <div className={cx("section")}>
          <h2 className={cx("section-title")}>Tổng điểm</h2>
          <div className={cx("table-container")}>
            <table className={cx("table")}>
              <thead>
                <tr>
                  <th>Thời gian</th>
                  <th>Số điện thoại</th>
                  <th>Tổng điểm</th>
                </tr>
              </thead>
              <tbody>
                {summary.map((row, index) => (
                  <tr key={index}>
                    <td>{row[0]}</td>
                    <td>{row[1]}</td>
                    <td>{row[2]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {history.length > 0 && (
        <div className={cx("section")}>
          <h2 className={cx("section-title")}>Lịch sử tích điểm</h2>
          <div className={cx("table-container")}>
            <table className={cx("table")}>
              <thead>
                <tr>
                  <th>Thời gian</th>
                  <th>Số điện thoại</th>
                  <th>Điểm</th>
                </tr>
              </thead>
              <tbody>
                {history.map((row, index) => (
                  <tr key={index}>
                    <td>{row[0]}</td>
                    <td>{row[1]}</td>
                    <td>{row[2]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {history.length === 0 &&
        summary.length === 0 &&
        !error &&
        !loading &&
        searched && (
          <p className={cx("notification")}>
            Không tìm thấy lịch sử hoặc tổng điểm cho số điện thoại này
          </p>
        )}

      {history.length === 0 &&
        summary.length === 0 &&
        !error &&
        !loading &&
        !searched && (
          <p className={cx("empty-message")}>
            Nhập số điện thoại để xem lịch sử
          </p>
        )}

      <NavLink to={routes.home} className={cx("house")}>
        <FontAwesomeIcon icon={faHouse} />
      </NavLink>
    </div>
  );
}

export default History;
